module.exports = function(cb, err) {
	require.ensure([], function() {
		cb(require(
"!!../../../../../../../../../assets/node_modules/esbuild-loader/dist/index.cjs??clonedRuleSet-219.use[0]!../../../../../../../../../assets/node_modules/string-replace-webpack-plugin/loader.js?id=6xbdelbqvns!./locale.bundle.js"
));
	}, function() {
		if (err) err.apply(this, arguments);
	});
};